'use strict';

class Projects {
  constructor($scope, $window, $sce, $filter, timeTrackingService, I18N) {
    this.$scope = $scope;
    this.$window = $window;
    this.$sce = $sce;
    this.$filter = $filter;
    this.timeTrackingService = timeTrackingService;
    this.I18N = I18N;
  }

  $onInit() {
    this.alert = {};

    this.project = {
      number: null,
      name: null
    };

    this.task = {
      number: null,
      projectNumber : null,
      name: null
    };

    this.projects = [];
    this.tasks = [];

    this.loadProjects();
  }

  loadProjects() {
    this.timeTrackingService.getProjects()
      .then((resp) => {
        this.projects = resp.data;
      });
  }

  calculateDayTotal() {
    this.dayTotal = '0:00';
    let hours = 0;
    let mins = 0;

    this.selectedDayEntries.forEach((e) => {
      let hoursMinutes = e.hours.split(':');
      hours += parseInt(hoursMinutes[0], 10);
      if (hoursMinutes.length > 1) {
        mins += parseInt(hoursMinutes[1], 10);
      }
    });

    let extraHours = Math.floor(mins / 60);
    hours += extraHours;
    let minutes = mins % 60;
    let extraZero = minutes < 10 ? '0' : '';
    let res = hours + ':' + extraZero + minutes;
    this.dayTotal = res;
  }

  loadTasks(projectNumber) {
    this.tasks = [];
    if (projectNumber === 1) {
      this.tasks.push({
        number: 1,
        name: 'Software development 1'
      });
      this.tasks.push({
        number: 2,
        name: 'Software development 2'
      });
    } else if (projectNumber === 2) {
      this.tasks.push({
        number: 3,
        name: 'Design  1'
      });
      this.tasks.push({
        number: 4,
        name: 'Design  2'
      });
    } else if (projectNumber === 3) {
      this.tasks.push({
        number: 5,
        name: 'Test task'
      });
      this.tasks.push({
        number: 6,
        name: 'Sample task'
      });
    }
  }

  editProject(index) {
    let clone = angular.copy(this.selectedDayEntries[index]);
    this.loadTasks(clone.projectNumber);
    this.project = clone;
  }
}

Projects.$inject = ['$scope', '$window', '$sce', '$filter', 'timeTrackingService', 'I18N'];

const projects = {
  controller: Projects,
  templateUrl: 'time-track/projects.html'
};

angular
  .module('SendRegning')
  .component('projects', projects)
  .config(($routeProvider) => {
    $routeProvider
      .when('/timeregistrering/prosjekter', {
        title: 'Timeregistrering Prosjekter',
        template: '<projects />',
        secure: true
      });
  });
